import { createSlice } from '@reduxjs/toolkit';
import Cookies from 'js-cookie';
import {
	FORM_PERSISTENCE_COOKIE_EXPIRATION,
	FORM_PERSISTENCE_COOKIE_NAME,
} from '../../utils/constants';

export const formPersistenceSlice = createSlice({
	name: 'formPersistence',
	initialState: {
		formData: {},
	},
	reducers: {
		saveFormData: (state, action) => {
			const { formKey, data } = action.payload;

			state.formData[formKey] = data;

			Cookies.set(FORM_PERSISTENCE_COOKIE_NAME(formKey), JSON.stringify(data), {
				expires: FORM_PERSISTENCE_COOKIE_EXPIRATION,
				path: '/',
			});
		},
		clearFormData: (state, action) => {
			const { formKey } = action.payload;

			Cookies.remove(FORM_PERSISTENCE_COOKIE_NAME(formKey));
		},
	},
});

export const { saveFormData, clearFormData } = formPersistenceSlice.actions;
export default formPersistenceSlice.reducer;
